import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatBold20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextFormatBold20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M14.574 6.8c0-2.36-1.667-3.8-4.729-3.8H5v14h4.922C13.314 17 15 15.58 15 12.9c0-1.52-.892-2.88-2.83-3.08 1.57-.24 2.404-1.56 2.404-3.02m-6.512-.94h1.492c1.376 0 1.86.62 1.86 1.36 0 .82-.484 1.36-1.53 1.36H8.062zm3.799 6.82c0 .96-.698 1.48-1.977 1.48H8.062v-2.94h1.802c1.376 0 1.996.46 1.996 1.46"
            />
        </svg>
    );
}
export default memo(IconTextFormatBold20);
